import { utilities, triggerEvent } from '@cornerstonejs/core';

import {
  getAnnotationNearPoint,
  getAnnotationNearPointOnEnabledElement,
} from './getAnnotationNearPoint';

// Lodash/common JS functionality
import debounce from './debounce';
import throttle from './throttle';
import isObject from './isObject';
import calibrateImageSpacing from './calibrateImageSpacing';
import {
  getCalibratedLengthUnitsAndScale,
  getCalibratedProbeUnitsAndValue,
  getCalibratedAspect,
} from './getCalibratedUnits';
import triggerAnnotationRenderForViewportIds from './triggerAnnotationRenderForViewportIds';
import triggerAnnotationRenderForToolGroupIds from './triggerAnnotationRenderForToolGroupIds';
import triggerAnnotationRender from './triggerAnnotationRender';

import { getSphereBoundsInfo } from './getSphereBoundsInfo';
import sampleAreaAnnotationVoxels from './sampleAreaAnnotationVoxels';
import { pointToString } from './pointToString';
import AnnotationMultiSlice from './AnnotationMultiSlice';
import getViewportForAnnotation from './getViewportForAnnotation';
import {
  annotationHydration,
  getClosestImageIdForStackViewport,
} from './annotationHydration';
// name spaces
import * as contours from './contours';
import * as segmentation from './segmentation';
import * as drawing from './drawing';
import * as math from './math';
import * as planar from './planar';
import * as spatial from './spatial';
import * as viewportFilters from './viewportFilters';
import * as orientation from './orientation';
import * as cine from './cine';
import * as boundingBox from './boundingBox';
import * as draw3D from './draw3D';
import * as planarFreehandROITool from './planarFreehandROITool';
import * as rectangleROITool from './rectangleROITool';
import { stackPrefetch, stackContextPrefetch } from './stackPrefetch';
import * as viewport from './viewport';
import * as touch from './touch';
import * as dynamicVolume from './dynamicVolume';
import * as polyDataUtils from './polyData/utils';
import * as voi from './voi';
import * as contourSegmentation from './contourSegmentation';
import { pointInSurroundingSphereCallback } from './pointInSurroundingSphereCallback';
const roundNumber = utilities.roundNumber;
import normalizeViewportPlane from './normalizeViewportPlane';
import IslandRemoval from './segmentation/islandRemoval';
import {
  getPixelValueUnits,
  getPixelValueUnitsImageId,
} from './getPixelValueUnits';
import * as geometricSurfaceUtils from './geometricSurfaceUtils';
import setAnnotationLabel from './setAnnotationLabel';
import { moveAnnotationToViewPlane } from './moveAnnotationToViewPlane';
import { safeStructuredClone } from './safeStructuredClone';
import getOrCreateImageVolume from './segmentation/getOrCreateImageVolume';
import * as usFanExtraction from '../tools/annotation/UltrasoundPleuraBLineTool/utils/fanExtraction';
import {
  jumpToFocalPoint,
  getViewSlabDepthOfViewport,
} from './genericViewportToolHelpers';
import pickIntensityPointInSlab, {
  getSlabIntensityPickContext,
} from './pickIntensityPointInSlab';

export * from './defaultGetTextLines';

export {
  math,
  planar,
  spatial,
  viewportFilters,
  drawing,
  debounce,
  dynamicVolume,
  throttle,
  orientation,
  isObject,
  touch,
  triggerEvent,
  calibrateImageSpacing,
  getCalibratedLengthUnitsAndScale,
  getCalibratedProbeUnitsAndValue,
  getCalibratedAspect,
  getPixelValueUnits,
  getPixelValueUnitsImageId,
  segmentation,
  contours,
  triggerAnnotationRenderForViewportIds,
  triggerAnnotationRenderForToolGroupIds,
  triggerAnnotationRender,
  getSphereBoundsInfo,
  sampleAreaAnnotationVoxels,
  getAnnotationNearPoint,
  getViewportForAnnotation,
  getAnnotationNearPointOnEnabledElement,
  viewport,
  cine,
  boundingBox,
  draw3D,
  rectangleROITool,
  planarFreehandROITool,
  stackPrefetch,
  stackContextPrefetch,
  roundNumber,
  pointToString,
  polyDataUtils,
  voi,
  AnnotationMultiSlice,
  contourSegmentation,
  annotationHydration,
  getClosestImageIdForStackViewport,
  pointInSurroundingSphereCallback,
  normalizeViewportPlane,
  IslandRemoval,
  geometricSurfaceUtils,
  usFanExtraction,
  setAnnotationLabel,
  moveAnnotationToViewPlane,
  safeStructuredClone,
  getOrCreateImageVolume,
  jumpToFocalPoint,
  getViewSlabDepthOfViewport,
  pickIntensityPointInSlab,
  getSlabIntensityPickContext,
};
